import React, { Component } from 'react';
import styled from 'styled-components';
import { Box, Flex, Image } from 'rebass';
import Text from './common/Text';
import styledProps from 'styled-props';
import { colors, fonts, textSizes, fontWeights } from './../tailwind';

const SummaryContainer = styled.div`
  width: 317px;
  height: 645px;
  background-color: ${colors.white};
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24);
`;

const Img = styled.div`
  width: 285px;
  height: 175px;
  background-image: url(${props => props.src});
  background-size: cover; 
  background-position: center center; 
  background-repeat: no-repeat; 
  margin: 16px;
  border-radius: 0px;
`;
// const Img = styled.img`
//   width: 285px;
//   height: 175px;
//   margin: 16px;
// `;

const CalPlaceholder = styled.div`
  width: 285px;
  height: 38px;
  border-radius: 4px;
  border: solid 1px ${styledProps(colors, 'color')};
  margin: 0px 16px;
  font-family: Helvetica;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: #119cb2;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Line = styled.div`
  width: 285px;
  height: 1px;
  background-color: ${styledProps(colors, 'color')};
  margin: 0px 16px;
`;

const Cursor = styled.div`
  cursor: pointer;
`;

export default class RequestSummary extends Component {

  state = {
    daysDiff: this.calculateDays(this.props.checkIn, this.props.checkOut),
    serviceFee: 7.5
  }

  calculateDays(checkIn, checkOut) {
    // milliseconds in one day
    const dayMilliseconds = 1000 * 60 * 60 * 24;
    // Convert date string to date object, then to milliseconds
    const checkInMs = new Date(checkIn).getTime();
    const checkOutMs = new Date(checkOut).getTime();
    // Diff in milliseconds between pickup/out
    const dateDiffMs = Math.abs(checkInMs - checkOutMs);
    // Convert from milliseconds to days
    // Add one day to include start and end days, not just difference
    return Math.round(dateDiffMs / dayMilliseconds) + 1;
  }

  dateFormatter(dateString) {
    const dateObj = new Date(dateString);
    const day = dateObj.getDate();
    const formattedDay = day.toString().length === 1 ? `0${day}` : day;
    const month = dateObj.getMonth() + 1;
    const formattedMonth = month.toString().length === 1 ? `0${month}` : month;
    return `${formattedMonth}/${formattedDay}`;
  }

  dollarFormatter(amount) {
    const decimal = amount.toString().split('.');
    if (decimal[1]) {
      if (decimal[1].length === 1) {
        decimal[1] += '0';
        return `$${decimal.join('.')}`;
      } else if (decimal[1].length === 2) {
        return `$${decimal.join('.')}`;
      }
    } else {
      decimal.push('00');
      return `$${decimal.join('.')}`;
    }
  }

  subTotal(basePrice, daysDiff) {
    return this.dollarFormatter(basePrice * daysDiff);
  }

  totalAmount(basePrice, serviceFee, daysDiff) {
    const { change } = this.props;
    const total = (basePrice * daysDiff) + serviceFee;
    change('basePrice', basePrice)
    change('rentalDays', daysDiff)
    change('serviceFee', serviceFee)
    change('totalAmount', total)
    return this.dollarFormatter(total);
  }

  render() {
    const { basePrice, checkIn, checkOut, listData, change } = this.props;
    const { daysDiff, serviceFee } = this.state;
    console.log('summary props: ', this.props);
    return (
      <SummaryContainer>
        <Flex flexDirection="column">
          <Box ml={16} mt={24}>
            <Text
              header
              xl
              bold
              primary
            >
              {listData.title}
            </Text>
          </Box>
          <Img ml={16} mt={16} src={`/images/upload/${listData.listPhotos[0].name}`} />
          <CalPlaceholder primary>
            <Text
              text
              lg
              primary
              noclip
            >
              From {this.dateFormatter(checkIn)} - To {this.dateFormatter(checkOut)}
            </Text>
          </CalPlaceholder>
          <Flex m={16} justifyContent="space-between">
            <Text
              text
              lg
              grayDark
              noclip
            >
              ${basePrice}/day x {daysDiff} {daysDiff === 1 ? 'day' : 'days'}
            </Text>
            <Text
              text
              lg
              grayDark
              noclip
            >
              {this.subTotal(basePrice, daysDiff)}
            </Text>
          </Flex>
          <Flex ml={16} mr={16} mb={16} justifyContent="space-between">
            <Text
              text
              lg
              grayDark
              noclip
            >
              Service fee
            </Text>
            <Text
              text
              lg
              grayDark
              noclip
            >
              {this.dollarFormatter(serviceFee)}
            </Text>
          </Flex>
          <Line primary />
          <Flex ml={16} mt={24} mr={16} justifyContent="space-between">
            <Text
              text
              lg
              grayDark
              noclip
            >
              Total
            </Text>
            <Text
              header
              bold
              xl
              grayDark
              noclip
            >
              {this.totalAmount(basePrice, serviceFee, daysDiff)}
            </Text>
          </Flex>
          <Box mt={24} ml={16}>
            <Text
              bold
              text
              sm
              grayDark
            >
              Cancelation Policy
            </Text>
          </Box>
          <Box mt={8} ml={16} mr={16}>
            <Text
              text
              sm
              grayDark
              noclip
              style={{ lineHeight: 1.2 }}
            >
              This rental can be canceled 48 before with no penalty.
            </Text>
          </Box>
          <Box mt={16} ml={16}>
            <Text
              bold
              text
              sm
              grayDark
              noclip
            >
              Insurance
            </Text>
          </Box>
          <Box mt={8} ml={16} mr={16}>
            <Text
              text
              sm
              grayDark
              noclip
              style={{ lineHeight: 1.2 }}
            >
              You are liable for any loss or damage to this item.
            </Text>
          </Box>
          <Box mt={8} ml={16} mr={16}>
            <Text
              text
              sm
              primary
              noclip
            >
              <Cursor>Terms & Conditions</Cursor>
            </Text>
          </Box>
        </Flex>
      </SummaryContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_new/RequestSummary.js